<section class="app2 header overflow-unset mb-4" id="home" #home>
  <div class="app2-header bg">
    <div class="container">
      <div class="row">
        @defer(when headerText) {
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <h6 class="header-top-line"></h6>
              <div class="header-text">
                <h1><b>{{headerText}}</b></h1>
              </div>
              <div class="header-sub-text">
                <p class="text-white">{{headerSubText}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="img-mobile set-abs text-center">
            <img [src]="headerImage?.data?.attributes?.url" [alt]="headerImage?.data?.attributes?.alternativeText"
              loading="lazy" fetchpriority="high" class="headaer-image">
          </div>
        </div>
        }
        @placeholder {
        @switch (screenSize$ | async) {
        @case ('xsmall') {
        <!-- Conteúdo para telas muito pequenas -->
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <div class="header-text">
                <ngx-skeleton-loader [theme]="{ width:'21.5rem' }" />
              </div>
              <div class="header-sub-text">
                <p class="text-white">
                  <ngx-skeleton-loader [appearance]="'line'" count="4" [theme]="{ width:'21.5rem' }" />
                </p>
              </div>
            </div>
          </div>
        </div>
        }
        @case('small'){
        <!-- Conteúdo para telas pequenas -->
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <div class="header-text">
                <ngx-skeleton-loader [theme]="{ width:'20rem' }" />
              </div>
              <div class="header-sub-text">
                <p class="text-white">
                  <ngx-skeleton-loader [appearance]="'line'" count="4" [theme]="{ width:'20rem' }" />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="img-mobile set-abs text-center">
            <ngx-skeleton-loader class="headaer-image" [appearance]="'line'" count="1"
              [theme]="{width:'275px', height:'375px'}"></ngx-skeleton-loader>
          </div>
        </div>
        }
        @case('medium'){
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <div class="header-text">
                <ngx-skeleton-loader [theme]="{ width:'20rem' }" />
              </div>
              <div class="header-sub-text">
                <p class="text-white">
                  <ngx-skeleton-loader [appearance]="'line'" count="4" [theme]="{ width:'20rem' }" />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="img-mobile set-abs text-center">
            <ngx-skeleton-loader class="headaer-image" [appearance]="'line'" count="1"
              [theme]="{width:'20.625rem', height:'37.625rem'}"></ngx-skeleton-loader>
          </div>
        </div>
        }
        @case('large'){
        <!-- Conteúdo para telas grandes -->
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <div class="header-text">
                <ngx-skeleton-loader [theme]="{ width:'26rem', marginLeft:'4.5rem' }" />
              </div>
              <div class="header-sub-text">
                <p class="text-white">
                  <ngx-skeleton-loader [appearance]="'line'" count="4"
                    [theme]="{ width:'26rem', display: 'flex', marginLeft:'4.5rem' }" />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="img-mobile set-abs text-center">
            <ngx-skeleton-loader class="headaer-image" [appearance]="'line'" count="1"
              [theme]="{width:'20.625rem', height:'37.625rem'}"></ngx-skeleton-loader>
          </div>
        </div>
        }
        @default {
        <div class="col-xl-7 col-md-6">
          <div class="center-text">
            <div class="container-header">
              <div class="header-text">
                <ngx-skeleton-loader [theme]="{ width:'26rem', marginLeft:'4.5rem' }" />
              </div>
              <div class="header-sub-text">
                <p class="text-white">
                  <ngx-skeleton-loader [appearance]="'line'" count="4"
                    [theme]="{ width:'26rem', display: 'flex', marginLeft:'4.5rem', marginBottom:'1.5rem' }" />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-md-6">
          <div class="img-mobile set-abs text-center">
            <ngx-skeleton-loader class="headaer-image" [appearance]="'line'" count="1"
              [theme]="{width:'20.625rem', height:'37.625rem'}"></ngx-skeleton-loader>
          </div>
        </div>
        }
        }
        }
      </div>
    </div>
    <div class="wave"></div>
  </div>
</section>